<template>
  <v-row :class="'ma-0 pl-0 '+ bg_color +' fixed zi-94 '+width_class+' '" no-gutters :justify="'space-between'">
    <v-col class="ma-0   pa-2 d-flex justify-start ">
      <v-btn small dense  text color="primary" @click="on_click_back" >
          <v-icon left class="mobile-display-none">mdi-keyboard-backspace</v-icon> Back
      </v-btn>
    </v-col>
    <v-col :cols="navbar_cols" class="text-capitalize text-center font-weight-medium pt-2">{{(show_staff)?title:''}}</v-col>
    <v-col class="ma-0  pa-2  pr-6 d-flex justify-end" >
      <v-breadcrumbs class="pa-0 " :items="(show_staff)?crumps:[]"></v-breadcrumbs>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "CenterNavBar",
  props: {
    navbar_cols: {
      type: [String,Number],
      default: 4
    },
    crumps: {
      type: Array,
      default: () => {
        return []
      }
    },
    width_class:{
      type: String,
      default: "wdth-50p"
    },
    title: {
      type: String,
      default: ""
    },
    bg_color: {
      type: String,
      default: "bg-white"
    },
    show_staff: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
  }),
  methods:{
    on_click_back(){
      this.$router.go(-1);
      this.$emit("on-go-back")
    }
  }
};
</script>